import { render, staticRenderFns } from "./TransformationForm.vue?vue&type=template&id=4f8309c3&scoped=true"
import script from "./TransformationForm.vue?vue&type=script&lang=js"
export * from "./TransformationForm.vue?vue&type=script&lang=js"
import style0 from "./TransformationForm.vue?vue&type=style&index=0&id=4f8309c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8309c3",
  null
  
)

export default component.exports